import * as React from 'react';
import useCombinedTranscriptions from './useCombinedTranscriptions';

export default function TranscriptionView() {
	const combinedTranscriptions = useCombinedTranscriptions();
	const containerRef = React.useRef<HTMLDivElement>(null);

	// Scroll to bottom when new transcription is added
	React.useEffect(() => {
		if (containerRef.current) {
			containerRef.current.scrollTop = containerRef.current.scrollHeight;
		}
	}, [combinedTranscriptions]);

	return (
		<div className="relative h-64 w-full max-w-full">
			{/* Fade-out gradient masks */}
			<div className="absolute top-0 left-0 right-0 h-6 bg-gradient-to-b from-white to-transparent z-10 pointer-events-none" />
			<div className="absolute bottom-0 left-0 right-0 h-6 bg-gradient-to-t from-white to-transparent z-10 pointer-events-none" />

			{/* Scrollable content */}
			<div
				ref={containerRef}
				className="h-full flex flex-col gap-3 overflow-y-auto px-4 py-6 scrollbar-thin scrollbar-thumb-indigo-200 scrollbar-track-transparent"
			>
				{combinedTranscriptions.map((segment) => (
					<div
						id={segment.id}
						key={segment.id}
						className={`max-w-[80%] rounded-2xl p-3 ${
							segment.role === 'assistant'
								? 'self-start bg-indigo-50 text-gray-800 border border-indigo-100'
								: 'self-end bg-indigo-600 text-white'
						}`}
					>
						{segment.text}
					</div>
				))}

				{/* Add some bottom padding to ensure last message is fully visible */}
				<div className="h-2" />
			</div>
		</div>
	);
}
